import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import FormLabel from '@material-ui/core/FormLabel';
import Typography from '@material-ui/core/Typography';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';

import { addFile } from '../../store/actions/session.actions';
import { addMessage } from '../../store/actions/message.actions';

import DropzoneComponent from '../common/dropzone.component';

const styles = theme => ({
  wrapper: {
    margin: theme.spacing.unit,
    position: 'relative',
  },
  icon: {
    marginRight: theme.spacing.unit,
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
});

class SingleFileUploadContainer extends React.Component {
  constructor(props) {
    super(props);

    this.onFileChange = this.onFileChange.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
    this.toggle = this.toggle.bind(this);
    this.cancel = this.cancel.bind(this);

    this.state = {
      isOpen: false,
      isUploadingFile: false,
      templateFile: '',
      templateFileName: '',
      name: '',
      files: [],
      fileNames: [],
    };
  }

  onFileChange(files) {
    const newFiles = this.state.files;
    newFiles.push(...files)

    const newFileNames = newFiles.map(file => { return file.name });

    this.setState({
      files: newFiles,
      fileNames: newFileNames,
    });
  }

  handleUpload(e) {
    if (!this.state.files[0]) {
      this.props.addMessage('error', 'No files selected');
      return;
    }

    this.setState({ isUploadingFile: true });

    this.props.addFile(this.state, this.props.sessionId).then(() => {
      this.props.addMessage('success', 'File(s) added');
    }).catch((e) => {
      console.error(e);
      this.props.addMessage('error', 'Something went wrong try again later');
    });
  }

  toggle(e) {
    this.setState({ isOpen: !this.state.isOpen, isUploadingFile: false });
  }

  cancel(e) {
    this.toggle();
  }

  render() {
    const { fileNames } = this.state;
    const { classes } = this.props;

    return (
      <span>
        <Button
          color="primary"
          onClick={this.toggle}
        >
          <Icon className={classes.icon}>add</Icon>
          Add file
        </Button>

        <Dialog
          open={this.state.isOpen}
          onClose={this.toggle}
          aria-labelledby="simple-dialog-title"
        >
          <DialogTitle>Add file to session</DialogTitle>
          <DialogContent>
            <DropzoneComponent
              text={`Drop your files here`}
              onFileChange={this.onFileChange}
            />
            <FormLabel>Files</FormLabel><br />
            {
              !fileNames[0] ? <Typography variant="body2">No files selected</Typography> : fileNames.map((filename, index) => { return (<Typography key={index} variant="body2">{filename}</Typography>) })
            }
          </DialogContent>
          <DialogActions>
            <Button onClick={this.cancel} color="secondary" autoFocus>Cancel</Button>
            <div className={classes.wrapper}>
              <Button onClick={this.handleUpload} color="secondary" disabled={this.state.isUploadingFile} >Upload</Button>
              {this.state.isUploadingFile && <CircularProgress className={classes.buttonProgress} size={24} color="secondary" />}
            </div>
          </DialogActions>
        </Dialog>
      </span>
    );
  }
}

SingleFileUploadContainer.propTypes = {
  sessionId: PropTypes.string.isRequired,
  callback: PropTypes.func,
  addFile: PropTypes.func.isRequired,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  /* eslint-enable */
};

const mapStateToProps = ({ status: { isUploadingFile } }) => ({
  isUploadingFile,
});

export default withStyles(styles)(connect(mapStateToProps, { addFile, addMessage })(SingleFileUploadContainer));
